import dio, { DioContext, DioType } from './init';

export default {
  clickGuestyCapitalDiamondOption: () =>
    dio.track(
      'diamond_menu_option_clicked',
      DioType.CLICK,
      {},
      DioContext.GUESTY_CAPITAL
    ),
};
